<template>
<!-- 选对支付成功 -->
  <div class="xd-pay-success">
      <div class="head">
          <img  src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/success-icon.png" alt="">
          <h4>付款成功</h4>
      </div>
      <!--  -->
      <div class="main">
          <div class="qrcode-img">
              <img  src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/success-icon.png" alt="">
          </div>
          <h4>添加客服微信，为您匹配咨询师</h4>
      </div>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            
        }
    },
    methods:{
        // 初始化获取数据
        pullData(){
            document.title = '添加老师';
            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #F7F8F9;
    }
</style>
<style lang="scss" scoped>
.xd-pay-success{
    position: relative;
    padding: 20px 30px 140px;
    .head{
        padding: 40px;
        margin-bottom: 20px;
        background: #FFFFFF;
        border-radius: 20px;
        text-align: center;
        overflow: hidden;
        img{
            width: 86px;
            height: 86px;
            margin-bottom: 16px;
        }
        h4{
            font-size: 32px;
            font-weight: 600;
            color: #2B333A;
            line-height: 48px;
        }
    }
    .main{
        background: #FFFFFF;
        border-radius: 20px;
        padding: 80px;
        overflow: hidden;
        text-align: center;
        .qrcode-img{
            width: 280px;
            height: 280px;
            background: #FFFFFF;
            border-radius: 20px;
            border: 2px solid #D8D8D8;
            padding: 20px;
            overflow: hidden;
            margin:0 auto 30px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        h4{
            font-size: 32px;
            font-weight: 600;
            color: #2B333A;
            line-height: 44px;
        }
    }

}

</style>